export default {
    //韩语
    DiagnosticReport:'진단 보고서',
    troubleCode:'장애 코드',
    time:'시간',
    // 语言
    lang:{
        cn:'중국어',
        de:'독일어',
        en:'영어',
        es:'스페인어',
        fr:'프랑스어',
        it:'이탈리아어',
        ja:'일본어',
        ko:'한국어',
        pt:'포르투갈어'
    },
    PositioningPrompt:'위치 기능을 켜서 현지 가격을 확인하세요',
    FaultCode:'고장 코드',
    AIDiagnosis:'AI 진단',
    AIWait:'AI 보고서 또는 자동 진단 대기',
    FailedFaultCode:'고장 코드 정보를 가져올 수 없습니다',
    AIError:'AI 분석 실패',
    more:'더 많은',
    StoredCodes:'코드 저장',
    PendingCodes:'처리할 코드',
    PermanentCodes:'영구 인코딩',
    Unknown:'알 수 없는',
    ManufacturerControl:'제조업체 통제',
    continue:'계속',
    // 引导定位
    notlimits:'위치 권한을 가져올 수 없습니다',
    setupSteps:'설정 단계:',
    openset:'"설정" 앱 열기',
    findSet:'사용 중인 앱 찾기',
    clickset:'"위치" 탭하기',
    selectLimits:'"앱 사용 중" 또는 "항상" 선택',
    blackRefresh:'앱으로 돌아가 페이지 새로고침',
    openAppSet:'"앱 관리" 또는 "앱" 탭하기',
    findUseBrowser:'사용 중인 브라우저 찾기',
    clickAuthority:'"권한 관리" 탭하기',
    findejurisd:'"위치" 권한 찾기',
    selectjurisd:'"허용" 또는 "사용 중에만 허용" 선택',
    phoneJurisd:'휴대전화 앱의 위치 권한 확인:',
    openJurisd:'"위치" 권한 켜기',
    report:'보고'
}